import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Dialog, DialogFooter, MessageBar, OkButton } from "@advosys/component-react";
import { hasValue } from "@advosys/component-react-utils";
import { k } from "./error-handler-i18n";
import { errorHandlerActions } from "./error-handler-store";
const mapStateToProps = (state) => ({
    message: state.application.errorHandler.message
});
const ErrorHandlerBase = (props) => {
    const { t } = useTranslation();
    const { message, hideError } = props;
    useEffect(() => {
        if (hasValue(message)) {
            console.log(`%c${new Date().toISOString()} ErrorHandler: ${message}`, "background: white; color: #db2b25");
        }
    }, [props.message]);
    if (hasValue(message)) {
        return (_jsx(Dialog, { header: t(k.header), size: "medium", onDismiss: hideError, footer: _jsx(DialogFooter, { children: _jsx(OkButton, { onClick: hideError }) }), children: _jsx(MessageBar, { messageBarType: "error", isMultiline: true, children: message }) }));
    }
    return null;
};
export const ErrorHandler = connect(mapStateToProps, errorHandlerActions)(ErrorHandlerBase);
